import React, {FC} from "react";
import {Route} from "react-router-dom";
import {Routes} from "react-router";
import {FundCoolingPage} from "backoffice/ui/Pages/Fund/CoolingOff";
import {FundTransferPage} from "backoffice/ui/Pages/Fund/Transfer";


export const FundPage: FC = () => {
  return (
      <Routes>
        <Route path="cooling-off" element={<FundCoolingPage/>}/>
        <Route path="transfer" element={<FundTransferPage/>}/>
      </Routes>
  );
}
